import NP from 'number-precision'

export function formatTime(time) {
  let timeDate = new Date(time)
  let nowDate = new Date()
  let now = nowDate.getTime()
  if(NP.minus(now, time) <= 60 * 1000) {
    return '刚刚'
  } else if(NP.minus(now, time) <= 60 * 60 * 1000) {
    return Math.floor(NP.divide(NP.minus(now, time), 60 * 1000)) + '分钟前'
  } else if(
    nowDate.getDate() === timeDate.getDate() 
    && nowDate.getMonth() === timeDate.getMonth() 
    && nowDate.getFullYear() === timeDate.getFullYear()
  ) {
    return `今天 ${timeDate.getHours()}:${timeDate.getMinutes()}`
  } else if(
    nowDate.getDate() <= (timeDate.getDate() + 2)
    && nowDate.getMonth() === timeDate.getMonth() 
    && nowDate.getFullYear() === timeDate.getFullYear()
  ) {
    return `${
      nowDate.getDate() - timeDate.getDate() === 1 
        ? '昨天' 
        : '前天'
    } ${timeDate.getHours()}:${timeDate.getMinutes()}`
  } else if(
    nowDate.getDate() > (timeDate.getDate() + 2)
    && nowDate.getMonth() === timeDate.getMonth() 
    && nowDate.getFullYear() === timeDate.getFullYear()
  ) {
    return `${timeDate.getMonth() + 1}月${timeDate.getDate()}日`
  } else if(
    nowDate.getMonth() === timeDate.getMonth()
    && nowDate.getFullYear() > timeDate.getFullYear()
  ) {
    return `${timeDate.getFullYear()}年${timeDate.getMonth() + 1}月${timeDate.getDate()}日`
  }
}

export function formatCount(count) {
  if(count < 10000) {
    return count
  } else if(count >= 10000 && count < 99999500){
    return NP.divide(Math.round(parseFloat(NP.divide(count, 1000).toFixed(1))), 10) + '万'
  } else if(count >= 99999500) {
    return NP.divide(Math.round(NP.divide(count, 10000000)), 10) + '亿'
  }
}